module.exports = __webpack_public_path__ + "img/en_2.7de3abcf.jpg";